export const UploadedBy = {
  Applicant: 0,
  Geosecma: 1,
  HandlingOfficer: 2
};
